/* 孫吳傳・第 17 章：白衣渡江（219 年）
 * 長江由西往東。北岸有一條沿江的小路，關羽沿江設了三座烽火台（屯候），東邊盡頭是江陵城。
 * 呂蒙的船從西邊江面出發，在第一座烽火台西邊的渡口靠岸。 */
export const TOWERS = [[2600, 1650], [4900, 1600], [7100, 1650]], DOCK = [1500, 2050], JIANGLING = [8600, 1500];
export default {
  id: 'jiangling', name: '江陵', W: 9200, H: 4400, seed: 219,
  bases: [[800, 3800], JIANGLING],
  rivers: [{ pts: [[-100, 2900], [3000, 2850], [6000, 2900], [9300, 2860]], hw: 700, fords: [] }],
  roads: [{ pts: [[DOCK[0], DOCK[1] - 100], [2600, 1900], [3800, 1850], [4900, 1850], [6000, 1900], [7100, 1900], [JIANGLING[0], JIANGLING[1] + 100]], w: 130 }],
  rocks: [[1800, 900, 400, 200], [4000, 800, 420, 200], [6100, 800, 400, 200], [8000, 3900, 400, 200]],
  woods: 0.5,
  sight: 0.6,
  clearings: [[TOWERS[0][0], TOWERS[0][1], 330], [TOWERS[1][0], TOWERS[1][1], 330], [TOWERS[2][0], TOWERS[2][1], 330], [JIANGLING[0], JIANGLING[1], 500], [DOCK[0], DOCK[1] - 150, 240]],
  marsh: [[DOCK[0], DOCK[1] + 80, 200, 110]],
  villages: [{ x: JIANGLING[0], y: JIANGLING[1] - 100, n: 7, r: 420 }],
};
